"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Collection_1 = require("../Collection");
class AnsweredQuestion {
    constructor() {
        this.chosenAnswerOptions = new Collection_1.default();
    }
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
        return this;
    }
    getChosenAnswerOptions() {
        return this.chosenAnswerOptions;
    }
    setChosenAnswerOptions(options) {
        this.chosenAnswerOptions = options;
        return this;
    }
    getValue() {
        return this.value;
    }
    setValue(value) {
        this.value = value;
        return this;
    }
    hasAnswer(value) {
        return this.getValue() === value ||
            (this.chosenAnswerOptions && !!this.chosenAnswerOptions.find((answer) => answer.getValue() === value));
    }
}
exports.default = AnsweredQuestion;
